import { useContext } from 'react';
import { FormHandlersContext } from '../../context/FormHandlersContext/FormHandlersContext';

export const useFormHandlersContext = () => {
  const context = useContext(FormHandlersContext);
  if (!context.isProvided) {
    throw new Error(
      'useFormHandlersContext must be used within a FormHandlersProvider'
    );
  }
  return context;
};
